import React from "react";

const AppleIcon = () => {
  return <img src="/Apple.svg" alt="apple" />;
};

export default AppleIcon;
